<template>
  <div class="content bg8">
    <div class="middled">
      <h1>
        Add a Tile
      </h1>
      <p>
        Tiles help you and your team focus and align on top priorities. 
      </p>
      <div>
        <div class="register">
          <form @submit.prevent="handleSubmit">
              <div class="form-grp">
                <label for="measure_name">Name</label>
                <input type="text" v-model="measure_name" name="measure_name" maxlength="144" />
              </div>
              <div class="form-grp">
                  <label for="measure_description">Description</label>
                  <textarea v-model="measure_description" name="measure_description" />
              </div>
              <div class="form-group">
                  <button class="btn btn-primary" :disabled="loading">Save</button> | <router-link :to="{ name: 'category', params: { scorecard_id: $route.params.scorecard_id, category_id: $route.params.category_id }}">Cancel</router-link>
                  <img v-show="loading" src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
              </div>
              <div v-if="error" class="alert alert-danger">{{error}}</div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { isLoggedIn } from "../utils/auth";
import { scorecardService } from '../_services';

export default {
  title: 'New Measure | Foclarity',
  name: "New-Measure",
  mounted: function() {
    if (isLoggedIn()) {
      // this.$router.push("dashboards");
    }
  },
  methods: {
    isLoggedIn() {
      return isLoggedIn();
    },
    activeScorecard: function () {
      this.scorecard = scorecardService.getActiveScorecard()
    },
    activeCategory: function () {
      this.category = scorecardService.getActiveCategory()
      if (this.category === null) {
        this.category = {"category_name": "..."}
        // console.log("no category loaded yet")
        this.$router.push({ name: 'category', params: { scorecard_id: this.scorecard.scorecard_id, category_id: this.category.category_id }})
      }
    },
    // eslint-disable-next-line no-unused-vars
    handleSubmit (e) {
        this.submitted = true;
        const { measure_name, measure_description } = this;

        this.loading = true;
        //console.debug("starting")
        scorecardService.createMeasure(measure_name, measure_description, this.scorecard.scorecard_id, this.category.category_id )
            .then(
                data => {
                    this.error = 'Measure ' + data.measure_name + ' created and saved. Returning to Category....';
                    this.loading = false
                    //console.debug(`/scorecards/` + this.scorecard.scorecard_id + `/categories/` + this.category.category_id)
                    window.location.href= `/scorecards/` + this.scorecard.scorecard_id + `/categories/` + this.category.category_id
                },
                error => {
                    //console.debug(error)
                    this.error = error;
                    this.loading = false;
                }
            );
    }    
  },
  components: {},
  data () {
      return {
        scorecard: '',
        category: '',
        measure_name: '',
        measure_description: '',
        submitted: false,
        loading: false,
        error: ''
      }
  },
  created () {
    this.activeScorecard() ;
    this.activeCategory() ;
  }
};
</script>

<style lang="scss" scoped>
</style>

